import { Heading, TextField, Flex, Text, Switch } from '@scale/scaleui-radix';
import { AuditRubricCriterion } from '@scale/shared-types';
import { CriterionQuestionText } from './CriterionQuestionText';

export const ViewCriterionName = ({
  criterion,
  renderedExtraInfo,
  showQuestionText = true,
}: {
  criterion: AuditRubricCriterion;
  renderedExtraInfo: JSX.Element | null;
  showQuestionText?: boolean;
}) => {
  return (
    <Flex direction="column" gap="1" width="100%">
      <Flex direction="row" align="center" justify="between" width="100%">
        <Heading size="2">{`Criterion: ${criterion.title}`}</Heading>
        {renderedExtraInfo}
      </Flex>
      {showQuestionText && <CriterionQuestionText criterion={criterion} />}
    </Flex>
  );
};

const EditCriterionName = ({
  criterion,
  setCriterion,
  error,
}: {
  criterion: AuditRubricCriterion;
  setCriterion: (criterion: AuditRubricCriterion) => void;
  error?: string;
}) => {
  return (
    <Flex direction="column" gap="2" width="100%">
      <Flex direction="row" justify="between" align="center">
        <Heading size="2">Criterion name</Heading>
        <Flex direction="row" gap="2" align="center">
          <Switch
            checked={criterion.required}
            onCheckedChange={() => setCriterion({ ...criterion, required: !criterion.required })}
          />
          <Text>Required</Text>
        </Flex>
      </Flex>
      <TextField.Root
        placeholder="Criterion title"
        value={criterion.title}
        onChange={e => setCriterion({ ...criterion, title: e.target.value })}
        className="w-full"
        color={error ? 'red' : undefined}
        style={error ? { boxShadow: 'inset 0 0 0 1px #dc2626' } : undefined}
      />
      {error && (
        <Text size="2" color="red">
          {error}
        </Text>
      )}
    </Flex>
  );
};

export const CriterionName = ({
  criterion,
  setCriterion,
  isEditingCriterion,
  renderedExtraInfo,
  error,
}: {
  criterion: AuditRubricCriterion;
  setCriterion: (criterion: AuditRubricCriterion) => void;
  isCriterionEditable: boolean;
  isEditingCriterion: boolean;
  renderedExtraInfo: JSX.Element | null;
  error?: string;
}) => {
  return isEditingCriterion ? (
    <EditCriterionName criterion={criterion} setCriterion={setCriterion} error={error} />
  ) : (
    <ViewCriterionName criterion={criterion} renderedExtraInfo={renderedExtraInfo} />
  );
};
